import React, { Fragment, useEffect } from 'react';
import { Trans, t } from '@lingui/macro';
import { connect } from 'dva';
import { createSelector } from 'reselect';

import { Heading } from '@mos-cat/typography';
import { Step } from '@mos-front-components/public/es/components/Steps';
import { StepProps } from '@mos-front-components/public/es/components/Steps/private/Step/Step';
import { SpouseNameChange } from '../Spouse/SpouseNameChange';
import { Spouse } from '../Spouse/Spouse';
import SpouseAddress from '../Spouse/SpouseAddress';
import SpouseDocument from '../SpouseDocument/SpouseDocument';
import {
  getSpouseStepCompleted,
  isSpouseDocumentIsRussianPassport,
} from '../../../selectors/spouse';
import { useStepCompleteSendStats } from '../../../helpers/stats';
import {
  getApplicantIsAddressCompleted,
  isApplicantMarried,
} from '../../../selectors/applicant';
import { isStatsSending } from '../../../selectors/submit';
import { sendCMAFormStepChange } from '../../../helpers/CMAstats';

interface Props {
  step?: StepProps;
  isMarried: boolean;
  disabled: boolean;
  stepCompleted: boolean;
  isStatsSending: boolean;
}

function SpouseData({
  step,
  isMarried,
  disabled,
  stepCompleted,
  isStatsSending,
}: Props): JSX.Element {
  useStepCompleteSendStats(isStatsSending, stepCompleted, {
    stepNumber: step,
    stepTitle: 'Сведения о супруге/втором родителе',
    childrenCount: null,
  });
  useEffect(() => {
    sendCMAFormStepChange();
  }, []);

  const content = disabled ? null : (
    <Fragment>
      <div className="StepContentBlock">
        <Spouse />
        <SpouseDocument />
      </div>
      <SpouseAddress />
      <SpouseNameChange />
    </Fragment>
  );
  return (
    <Step
      className="FormPage__Step"
      step={step}
      completed={stepCompleted}
      disabled={disabled}
      title={
        <Heading level={2} className="FormSteps__StepTitle">
          <Trans
            id={
              isMarried ? t`Сведения о супруге` : t`Сведения о втором родителе`
            }
          />
        </Heading>
      }
    >
      {content}
    </Step>
  );
}

export const mapStateToProps = createSelector(
  isApplicantMarried,
  getApplicantIsAddressCompleted,
  getSpouseStepCompleted,
  isSpouseDocumentIsRussianPassport,
  isStatsSending,
  (
    isMarried,
    isAddressCompleted,
    stepCompleted,
    isRussianPassport,
    isStatsSending
  ) => ({
    isMarried,
    disabled: !isAddressCompleted,
    stepCompleted,
    isRussianPassport,
    isStatsSending,
  })
);

export default connect(mapStateToProps)(SpouseData);
